/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { ApiResponse, CustomFormApiTypes } from 'lib-shared-types-api';

export function transformAttributesResponse(
  response: any,
): ApiResponse<CustomFormApiTypes['Form']> {
  response.data.attributes?.sort((a, b) => a.order_index - b.order_index);

  return response;
}
